import { lazy } from "react"
import { Redirect } from "react-router-dom"

import { PrivateRoute } from "./middleware/privateRoute"

// Dashboard
// const Dashboard = lazy(() => import("../pages/Dashboard/index"))
const OrganizationTab = lazy(() => import("../pages/Organization/index"))
const UserOrganizationTab = lazy(() => import("../pages/Organization/AdminOrganization/index"))
// const Organizationstaff = lazy(() => import("../pages/Organizationstaff/index"))
const Invite = lazy(() => import("../pages/Invite/index"))
const Edit = lazy(() => import("../pages/Edit/index"))

const InstitutionsTab = lazy(() => import("../pages/Institutions/index"))
const InstitutionsDash = lazy(() => import("../pages/Institutions/Dashboard/index"))
const UserInstitutionsDash = lazy(() => import("../pages/Institutions/AdminDashboard/index"))

const TeamdashboardTab = lazy(() => import("../pages/Teamdashboard/index"))
const teamdashboard = lazy(() => import("../pages/Teamdashboard/Dashboard/index"))
const Userteamdashboard = lazy(() => import("../pages/Teamdashboard/AdminDashboard/index"))

const PlayerslistTab = lazy(() => import("../pages/Playerslist/index"))
const Brain = lazy(() => import("../pages/Brain/index"))
const Xl_upload = lazy(() => import("../pages/Brain/xl_upload"))
const Brainupload = lazy(() => import("../pages/SimulationUpload/index"))
// const Brainremove = lazy(() => import("../pages/Brainremove/index"))
const Profile = lazy(() => import("../pages/Profile/index"))
const ProfilecomponentView = lazy(() => import("../pages/Profile/deviceDetect"))

const Teamanalytics = lazy(() => import("../pages/Teamanalytics/index"))
const PlayerDash = lazy(() => import("../pages/PlayerDash/index"))
const PlayerDashMob = lazy(() => import("../pages/PlayerDashMob/index"))
const Braindetails = lazy(() => import("../pages/Braindetails/index"))
const BraindetailsVideo = lazy(() => import("../pages/Braindetails/videoupload"))
const Playerdasboard = lazy(() => import("../pages/Playerdasboard/index"))
const DataCollection = lazy(() => import('../pages/DataCollection'))

// staff
const Staff = lazy(() => import("../pages/Staff/adminStaff"))
const orgStaff = lazy(() => import("../pages/Staff/organizationStaff"))
const institutionStaff = lazy(() => import("../pages/Staff/institutionStaff"))
const teamStaff = lazy(() => import("../pages/Staff/teamStaff"))
// const TeamStatsNew = lazy(() => import("../pages/TeamStats/indexNewtop20"))
const TeamStatsNew = lazy(() => import("../pages/TeamStats/indexNewtop20New"))
//const TeamStatsNew = lazy(() => import("../pages/TeamStats/indexNew"))
const CompleteSimulation = lazy(() => import("../pages/CompleteSimulation"))
const PendingSimulation = lazy(() => import("../pages/PendingSimulation"))
const FailedSimulation = lazy(() => import("../pages/FailedSimulation"))
// const OrgStats = lazy(() => import("../pages/OrgStats/index"))
const OrgStats = lazy(() => import("../pages/OrgStats/indexOrgTop20"))
//const OrgStatsNew = lazy(() => import("../pages/OrgStats/indexNew")) //neww
const InstitutionsStats = lazy(() => import("../pages/InstitutionsStats/index"))
const InstitutionsStatsTop20 = lazy(() => import("../pages/InstitutionsStats/indexNewTop20"))
//const InstitutionsStatsNew = lazy(() => import("../pages/InstitutionsStats/indexNew"))///new
const SimulationLog = lazy(() => import("../pages/SimulationLog/index"))
const UndefinedPlayers = lazy(() => import("../pages/Staff/undefiendPlayers"))
const teamSimsLogs = lazy(() => import("../pages/SimLog/index"))
const FamilyDash = lazy(() => import("../pages/Family/Dashboard/index"))
const ToolKit = lazy(() => import("../pages/ToolKit/index"))
const ToolKitPage = lazy(() => import("../pages/ToolKit/main"))
const FamilyStaff = lazy(() => import("../pages/Staff/familyStaff"))
const componentView = lazy(() => import("../pages/PlayerDashMob/mobileView"))
const PlayerDashNew = lazy(() => import("../pages/PlayerDashMob/mobileView"))
const BrainRegions = lazy(() => import("../pages/PlayerDashMob/BrainRegions"))
const DataAnalytics = lazy(() => import("../pages/Organization/data-analytics"))
const ClinicalTrial = lazy(() => import("../pages/ClinicalTrial"))
const DataSecurity = lazy(() => import("../pages/DataSecurity"))
const Details = lazy(() => import("../pages/DataSecurity/details"))
const CustomerDataAnalytics = lazy(() => import("../pages/DataAnalytics"))

const userRoutes = [
  // this route should be at the end of all other routes

  { path: "/user/dashboard", component: PrivateRoute, userAccessLevel: 100 },
  { path: "/invite/user/:type/:id?", component: Invite, userAccessLevel: 200 },
  { path: "/edit", component: Edit },

  { path: "/admin/staff", component: Staff, userAccessLevel: 1000 },
  { path: "/admin/data-analytics", component: DataAnalytics, userAccessLevel: 1000 },
  { path: "/dashboard", component: OrganizationTab, userAccessLevel: 1000 },
  { path: "/organization/staff/:id?", component: orgStaff, userAccessLevel: 300 },
  { path: "/user/organizations", component: UserOrganizationTab, userAccessLevel: 300 },
  { path: "/players/undefined", component: UndefinedPlayers, userAccessLevel: 1000 },
  { path: "/institutions/:org_id", component: InstitutionsDash, userAccessLevel: 300 },
  { path: "/user/institutions", component: UserInstitutionsDash, userAccessLevel: 250 },
  { path: "/orgStats/:_id?", component: OrgStats, userAccessLevel: 300 },
  //{ path: "/orgStats_new/:_id?", component: OrgStatsNew, userAccessLevel: 300 },///new


  { path: "/tab/institutions", component: InstitutionsTab, userAccessLevel: 1000 },
  { path: "/institution/staff/:id?", component: institutionStaff, userAccessLevel: 250 },
  { path: "/institutionsStats/:_id", component: InstitutionsStatsTop20, userAccessLevel: 250 },
 // { path: "/institutionsStats_new/:_id", component: InstitutionsStatsNew, userAccessLevel: 250 }, ///new

  { path: "/teams/:ins_id", component: teamdashboard, userAccessLevel: 200 },
  { path: "/user/teams", component: Userteamdashboard, userAccessLevel: 200 },
  { path: "/team/players/:team_id", component: TeamdashboardTab, userAccessLevel: 200 },
  { path: "/team/staff/:id?", component: teamStaff, userAccessLevel: 200 },

  { path: "/tab/playerslist", component: PlayerslistTab, userAccessLevel: 200 },
  { path: "/simulation/select-sensor/:team_id", component: Brain },
  { path: "/simulation/upload/:team_id", component: Brainupload },
  { path: "/xl/simulation/select-sensor/:team_id", component: Xl_upload },
  { path: "/profile/:_id?/:tab?", component: ProfilecomponentView },

  { path: "/teamanalytics", component: Teamanalytics },
  { path: "/player/dashboard/:_id", component: componentView },
  { path: "/player/dashboard_new/:_id", component: PlayerDashNew },//////neww
  { path: "/player/details/:event_id", component: Braindetails },
  { path: "/player/details-video/:event_id", component: BraindetailsVideo},
  { path: "/player/dashboard2", component: Playerdasboard, userAccessLevel: 100 },
  { path: "/teamstats/:_id?", component: TeamStatsNew, userAccessLevel: 200 },
  { path: "/clinical-trial/:team_id?", component: ClinicalTrial, userAccessLevel: 200 },
  // { path: "/teamstats_new/:_id?", component: TeamStatsNew,userAccessLevel: 200 }, //////neww

  { path: "/completeSimulation/:type/:_id?", component: CompleteSimulation },
  { path: "/failedSimulation/:type/:_id?", component: FailedSimulation },
  { path: "/pendingSimulation/:type/:_id?", component: PendingSimulation },

  { path: "/simulation/log/:event_id", component: SimulationLog, userAccessLevel: 100 },
  { path: "/sim/log/:team_id", component: teamSimsLogs, userAccessLevel: 100 },
  { path: "/family/:_id", component: FamilyDash, userAccessLevel: 150 },
  { path: "/staff/:_id?", component: FamilyStaff, userAccessLevel: 150 },
  { path: "/inviting/user/:type/:id?", component: Invite, userAccessLevel: 150 },
  { path: "/ml/toolkit/:type/:_id?", component: ToolKitPage, userAccessLevel: 100 },
  { path: "/ml/v2/toolkit/:type/:_id?", component: ToolKit, userAccessLevel: 100 },
  { path: "/player/data-collection/:_id", component: DataCollection},

  //code detail
  {path:"/player/brain-regions",component:BrainRegions},

  {path:"/data-security",  exact: true, component: DataSecurity, userAccessLevel: 1000},
  {path:"/compliance/:type", component: Details, userAccessLevel: 1000},

  {path: "/data-analytic/:type/:id", component: CustomerDataAnalytics, userAccessLevel: 200},

  { path: "/", exact: true, component: () => <Redirect to="/home" /> },
]

export default userRoutes;
